import { gql } from '@apollo/client';

export const GET_EXPENSES_REPORT = gql`
  query GetExpensesReport($filterInput: ExpensesReportFilterInput) {
    expensesReport(filterInput: $filterInput) {
      items {
        id
        incidentId
        contractId
        incidentSubject
        propertyName
        supplierName
        payerLabel
        payerUserType
        paidToSupplier
        collectedFromPayer
        title
        description
        date
        expenseCost
        invoiceNumber
        chargeStatus
        typeOption
        currencyOption
      }
      pagination {
        totalItems
        totalPages
        currentPage
        pageSize
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

